<template>
  <div class="report-user-content">
    <div class="row">
      <!-- Demo Request -->
      <div class="col-md-12">
        <b-card no-body>
          <!-- <b-card-header>
            <b-card-sub-title class="mb-25">
              {{ `Total de Solicitações de Demonstração: ${demoRequest}` }}
            </b-card-sub-title>
          </b-card-header>
          <b-card-header>
            <b-card-sub-title class="mb-25">
              {{ `Total de Solicitações de Demonstração por período: ${demoRequestByPeriod.totalPeriod || 0}` }}
            </b-card-sub-title>
          </b-card-header> -->
          <b-card-header class="statistics-filter-header">
              Filtro
          </b-card-header>
          <b-card-body class="report-demo-body">
            <b-overlay class="custom-overlay" :show="displayOverlayDemoRequestByPeriod" rounded="sm">
              <div class="d-flex col-md-6">
                <!-- <feather-icon icon="CalendarIcon" size="16" /> -->
                <flat-pickr
                  v-model="rangePickerReportDemoRequestByPeriod"
                  class="form-control-sm form-date"
                  :placeholder="$t('MANAGE_NEWS_FILTER.Period')"
                  :config="{
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    altInput: true,
                    altFormat: 'd/m/Y',
                    allowInput: true,
                    mode: 'range',
                  }"
                />
              </div>
              <div class="report-buttons">
                <b-button
                  class="search-button"
                  variant="primary"
                  size="sm"
                  @click="fetchDemoRequestByPeriod()"
                >
                  <feather-icon icon="SearchIcon" class="export-button-icon"/>
                  {{ $t("MANAGE_NEWS_FILTER.Search") }}
                </b-button>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="reportData()"
                >
                  <feather-icon icon="FileTextIcon" class="export-button-icon"/>
                  Exportar
                </b-button>
                <b-button 
                  variant="primary"
                  size="sm" 
                  @click="onClear"
                >
                  <feather-icon icon="TrashIcon"/>
                  {{ $t('MANAGE_NEWS_FILTER.Clear') }}
                </b-button>
              </div>

              <vue-perfect-scrollbar
                class="report-user-scroll-area"
                :suppressScrollX="true"
              >
                <div>
                  <!-- <b-card 
                    v-for="(item, index) in demoRequestByPeriod.data"
                    :key="index"
                    :header="item.date"
                  >
                    <b-list-group v-if="item.emails && item.emails.length">
                      <b-list-group-item 
                        v-for="(email, emailIndex) in item.emails"
                        :key="emailIndex"
                        href="#"
                      >
                        {{ email }}
                      </b-list-group-item>
                    </b-list-group>
                    <p v-else>Nenhuma solicitação de demonstração para este dia.</p>
                  </b-card> -->
                  <custom-g-table
                    v-if="displayTable"
                    :displayLoading="tableLoading"
                    ref="custom-table"
                    :fields="fields"
                    :items="demoRequestByPeriod"
                    :totalRows="totalRows"
                    :limit="limit"
                    :hasDeleteButton="false"
                    :hasUpdateDataButton="false"
                    :tableMaxHeight="tableMaxHeight"
                    @changePage="onChangePage"
                  />
                </div>
              </vue-perfect-scrollbar>
            </b-overlay>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  // BCardSubTitle,
  BButton,
  BOverlay,
  // BListGroup,
  // BListGroupItem
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ref, watch  } from "@vue/composition-api";
// import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import demoRequestService from "@/providers/demoRequestService";
import AppConstants from "@/appConstants";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import { useWindowSize } from "@vueuse/core";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';

export default {
  components: {
    VuePerfectScrollbar,
    BCardHeader,
    BCard,
    BCardBody,
    // BCardSubTitle,
    flatPickr,
    BButton,
    BOverlay,
    CustomGTable
    // BListGroup,
    // BListGroupItem
  },
  setup() {
    const displayOverlayDemoRequestByPeriod = ref(false);
    // const rangePickerReportDemoRequestByPeriod = ref(convertDatetimeHelper.getDateRangeFilterFormat());
    const rangePickerReportDemoRequestByPeriod = ref("");
    const demoRequest = ref(0);
    const page = ref(1);
    const demoRequestByPeriod = ref([]);
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelSpeed: 0.3,
      swipeEasing: true,
    };
    const displayTable= ref(false);
    const totalRows = ref(0);
    const limit = ref(AppConstants.PAGINATOR_DEFAULT_LIMIT);
    // const limit = ref(15);
    const tableLoading = ref(true);
    const fields = [
        {
          field: "dt_create",
          label: "Criação",
          type: "custom_date",
          sortable: false,
          // filterOptions: {
          //   filterValue: '',
          //   enabled: true,
          //   placeholder: "Pesquisar por data",
          //   trigger: "enter",
          // },
        },
        {
          field: "body.Nome",
          label: "Nome",
          sortable: false,
        },
        // {
        //   field: "dt_sent",
        //   label: "Data de Envio",
        //   type: "custom_date",
        //   sortable: false,
        //   // filterOptions: {
        //   //   filterValue: '',
        //   //   enabled: true,
        //   //   placeholder: "Pesquisar por data envio",
        //   //   trigger: "enter",
        //   // },
        // },
        // {
        //   field: "dt_update",
        //   label: "Data de Alteração",
        //   type: "custom_date",
        //   sortable: false,
        //   // filterOptions: {
        //   //   filterValue: '',
        //   //   enabled: true,
        //   //   placeholder: "Pesquisar por data",
        //   //   trigger: "enter",
        //   // },
        // },
        // { 
        //   field: "sent", 
        //   label: "Enviado", 
        //   type: "boolean", 
        //   sortable: false, 
        //   // filterOptions: { 
        //   //   filterValue: '', 
        //   //   enabled: true, 
        //   //   placeholder: 'Pesquisar por Enviado', 
        //   //   filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] 
        //   // } 
        // },
        {
          field: "email",
          label: "Email",
          sortable: false,
          // filterOptions: {
          //   filterValue: '',
          //   enabled: true,
          //   placeholder: "Pesquisar por Email",
          //   trigger: "enter",
          // },
        },
        {
          field: "body.DDD",
          label: "DDD",
          sortable: false,
        },
        {
          field: "body.Telefone",
          label: "Telefone",
          sortable: false,
        },
        // {
        //   field: "errorOnSent",
        //   label: "Erro ao Enviar",
        //   type: "boolean",
        //   sortable: false,
        //   // filterOptions: { 
        //   //   filterValue: '', 
        //   //   enabled: true, 
        //   //   placeholder: 'Pesquisar por Erro ao Enviar', 
        //   //   filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] 
        //   // },
        // },
        // {
        //   field: "errorMessage",
        //   label: "Mensagem de erro",
        //   sortable: false,
        //   // filterOptions: {
        //   //   filterValue: '',
        //   //   enabled: true,
        //   //   placeholder: "Pesquisar por Mensagem de erro",
        //   //   trigger: "enter",
        //   // },
        // },
        // {
        //   field: "body",
        //   label: "Body",
        //   sortable: false,
        // },
      ];

    const onChangePage = (newPage) => {
      page.value = newPage;
      fetchDemoRequestByPeriod();
    };

    // const fetchDemoRequest = () => {
    //   const params = new URLSearchParams();
    //   demoRequestService.getTotalDemoRequest(params)
    //     .then(res => {
    //       demoRequest.value = res.total;
    //     })
    //     .catch(err => console.error('Error fetching total demo request:', err));
    // };

    const fetchDemoRequestByPeriod = () => {
      tableLoading.value = true;
      demoRequestByPeriod.value = [];
      const params = new URLSearchParams();
      params.append("page", page.value);
      params.append("limit", limit.value);

      if (rangePickerReportDemoRequestByPeriod.value) {
        params.append("dt_range", rangePickerReportDemoRequestByPeriod.value);
      }
      demoRequestService.getall(params)
        .then(res => {
          demoRequestByPeriod.value = res.data;
          totalRows.value = res.totalRows;
          displayTable.value = true;
          tableLoading.value = false;
        })
        .catch(err => console.error('Error fetching demo request by period:', err))
    };

    const reportData = () => {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      
      if (rangePickerReportDemoRequestByPeriod.value) {
        params.append("dt_range", rangePickerReportDemoRequestByPeriod.value);
      }
      if (!rangePickerReportDemoRequestByPeriod.value || rangePickerReportDemoRequestByPeriod.value <= 0) {
        messagesNotifyHelper.errorNotify(
          "Erro",
          "Sem dados para exportar, verifique sua pesquisa e tente novamente"
        );
        return;
      }
      params.append("download", true);
      demoRequestService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'relatorio_de_demonstracao.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    };

    const onClear= () => {
      rangePickerReportDemoRequestByPeriod.value = "";
    };

    const tableMaxHeight = ref(AppConstants.CUSTOM_TABLE_DEFAULT_HEIGHT);
    const { height: windowheight } = useWindowSize();
    watch(windowheight, (val) => {
      if (val < 900) {
        tableMaxHeight.value = '200px';
      } else {
        tableMaxHeight.value = AppConstants.CUSTOM_TABLE_DEFAULT_HEIGHT;
      }
    },  { immediate: true });

    // fetchDemoRequest();

    return {
      tableLoading,
      limit,
      totalRows,
      fields,
      displayTable,
      reportData,
      demoRequest,
      demoRequestByPeriod,
      displayOverlayDemoRequestByPeriod,
      // fetchDemoRequest,
      fetchDemoRequestByPeriod,
      perfectScrollbarSettings,
      rangePickerReportDemoRequestByPeriod,
      onChangePage,
      onClear,
      tableMaxHeight
    };
  },
};
</script>

<style>
.report-demo-body {
  display: flex;
  flex-direction: column;
}
.report-demo-body .align-items-center {
  margin-bottom: 20px;
  width: auto;
}

.report-demo-body .form-date {
  width: 400px;
  margin-right: 20px;
}

.search-button {
  margin-right: 10px;
}

.export-button-icon {
  height: 13px;
  width: 13px;
}

.report-buttons button {
  margin-right: 10px;
}

.report-buttons {
  padding: .5rem;
}
</style>